import axios from "axios";
import {toast} from "react-toastify";

export const sendMessage = (message) => {
    return async dispatch => {
        try {
            await axios.post(`https://holz-city.ru:444/message`, message);
            toast.success('Сообщение отправлено!', {
                position: 'bottom-right',
                autoClose: false
            })
        } catch (e) {
            toast.error('Ошибка при отправке сообщения', {
                position: 'bottom-right',
                autoClose: false
            })
        }

    }
}